import { switcher, toID } from './utils';
import { ACTIONS } from '../const';
import R from 'ramda';

const membershipRecord = data => {
    return {
        id: null,
        resource_uri: true,
        last_pages: [],
        role: true,
        section: null,
        user: null,
        section_id: null,
        user_id: null,
        ...data,
    };
};

function fromServer(data) {
    return membershipRecord({
        ...data,
        section_id: toID(data.section),
        user_id: toID(data.user),
    });
}

export default switcher(
    {},
    {
        [ACTIONS.SYNC_MEMBERSHIP](state, action) {
            const membership = fromServer(action.membership);

            return {
                ...state,
                [membership.id]: membership,
            };
        },
        [ACTIONS.SET_LAST_PAGE](state, action) {
            const { contentId, membershipId, page } = action;

            return R.set(
                R.lensPath([
                    String(membershipId),
                    'last_pages',
                    String(contentId),
                ]),
                String(page),
                state
            );
        },
    }
);



// WEBPACK FOOTER //
// ./src/reducers/membership.js